module.exports = __webpack_public_path__ + "img/governate.532f350e.svg";